import { useBrochuresActivities } from '@/modules/careplan/hooks/useCareplanActivity'

export function usePendingDocumentCount() {
  const { data: brochuresActivities } = useBrochuresActivities()

  const pendingDocumentCount =
    brochuresActivities?.filter(
      (activity) =>
        activity.status === 'scheduled' &&
        (activity.meta?.messageType === 'Document' || activity.meta?.messageType === 'Brochure'),
    )?.length ?? 0

  return {
    pendingDocumentCount,
  }
}
